import { render, staticRenderFns } from "./RewardClassUpgrade.vue?vue&type=template&id=3f7e1b3f&scoped=true&"
import script from "./RewardClassUpgrade.vue?vue&type=script&lang=js&"
export * from "./RewardClassUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./RewardClassUpgrade.vue?vue&type=style&index=0&id=3f7e1b3f&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7e1b3f",
  null
  
)

export default component.exports